/**
 * @desc 查询挂牌商品详情
 */
import { ListingItem } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryListingParameter = {
  id?: string
}

const method = 'GET'
const url = '/trade/mall/listing'

export const queryListingApi = (
  params?: QueryListingParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<ListingItem>({
    method,
    url,
    params,
    ...config
  })
}

queryListingApi.method = method
queryListingApi.url = url
